import { GiftOutlined } from '@ant-design/icons';
import { lazyRouteComponent } from '@tanstack/react-router';

import { ACCOUNT_ROLE_CODES } from '@lib/types';
import { Route } from '@lib/types/route';
import { ROUTE_PATHS } from '@modules/route-paths';

const AdminCouponsPage = lazyRouteComponent(() => import('./pages/admin'));
const StoreCouponsPage = lazyRouteComponent(() => import('./pages/store'));

export const getRoutes = (): Route[] => [
  {
    page: AdminCouponsPage,
    path: ROUTE_PATHS.ADMIN_COUPONS,
    title: 'Cupons',
    icon: GiftOutlined,
    acl: [ACCOUNT_ROLE_CODES.ADMIN],
    adminSection: 'finance',
    adminOrder: 30,
  },
  {
    page: StoreCouponsPage,
    path: ROUTE_PATHS.STORE_COUPONS,
    title: 'Cupons da loja',
    hidden: true,
    icon: GiftOutlined,
  },
];
